import { Dispensary } from "custom-types/Dispensary";
import reservationApi from "../services/reservations";

export type CartData = {
  id: number;
  cartItems: Array<{
    quantity: number;
    packagePrice: number;
  }>;
  createdAt: string;
  dispensaryId: number;
  dispensaryData: Dispensary;
  reservationId: number;
  sessionId: string;
  userId: number;
};

export const getCart = async (
  cartId: string,
  countryCode: string
): Promise<CartData | null> => {
  try {
    const response = await reservationApi.get("/cart", {
      headers: {
        "X-Leafly-Id": cartId,
        "X-Country-Code": countryCode,
      },
    });

    return response?.data?.data as CartData;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }

    throw error;
  }
};
